import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommitteeApprovalsComponent } from './committee-approvals.component';
import { CommitteeApprovalComponent } from './committee-approval/committee-approval.component';
import { CommitteeApprovalsService } from './committee-approvals.service';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommitteeItemsModule } from '../committee-items/committee-items.module';

@NgModule({
  providers: [CommitteeApprovalsService],
  declarations: [CommitteeApprovalsComponent, CommitteeApprovalComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommitteeItemsModule,
  ],
  exports: [CommitteeApprovalsComponent],
})
export class CommitteeApprovalsModule {}
